import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
// @ts-ignore
import * as html2pdf from "html2pdf.js";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute } from "@angular/router";
import { ApprovalStatusEnum } from "src/app/services/enums/approval-status.enum";
import { publicPaymentsApi } from "src/app/services/constants/api.constants";
import { HelpersService, HttpBaseService } from "@evento-ng/libs";
import { NgxSpinnerService } from "ngx-spinner";
import { generateQR } from "src/app/shared/utils/qr-code.util";
@Component({
  selector: "app-html-design",
  templateUrl: "./html-design.component.html",
  styleUrls: ["./html-design.component.scss"],
})
export class HtmlDesignComponent implements OnInit {
  ApprovalStatusEnum = ApprovalStatusEnum;
  constructor(
    public translate: TranslateService,
    public dataService: HttpBaseService,
    private route: ActivatedRoute,
    public helpers: HelpersService,
    private spinner: NgxSpinnerService
  ) {
    this.invoiceId = this.route.snapshot.paramMap.get("id");
    console.log(this.invoiceId);
  }
  @ViewChild("pdfTable", { static: false }) pdfTable!: ElementRef;
  invoiceId;
  invoice: any = {};
  options = {
    margin: 0,
    filename: "Invoice.pdf",
    image: {
      type: "jpeg",
      quality: "1",
    },
    html2canvas: {
      scale: 3,
      allowTaint: false,
      useCORS: true,
    },
    jsPDF: {
      unit: "in",
      format: "letter",
      orientation: "portrait",
    },
  };
  ngOnInit(): void {}

  async ngAfterViewInit() {
    this.spinner.show();

    this.getDetails().subscribe({
      next: async (res: any) => {
        this.invoice = res;

        if (this.invoice?.tickets?.length) {
          for (const order of this.invoice.tickets) {
            order.generatedQrCode = await generateQR(order.id);

            order.mutedQrCode = await generateQR(order.id, "#cecece");
          }
        }

        this.spinner.hide();

        setTimeout(() => {
          this.downloadAsPDF();
        }, 1000);
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getDetails() {
    return this.dataService.get(
      `${publicPaymentsApi}/${this.invoiceId}/download-details`,
      { headers: { "Accept-Language": this.translate.currentLang } }
    );
  }

  public downloadAsPDF() {
    var element = document.getElementById("pdfTable");
    html2pdf().from(element).set(this.options).save();
  }
}
